import { userConstants } from "../constants/login.constants";

 function businessCertificateReport(state = {}, action) {
    switch (action.type) {
        case userConstants.BUSINESSCERTIFICATEREPORT_REQUEST:
            return {
                loading: true
            };
        case userConstants.BUSINESSCERTIFICATEREPORT_SUCCESS:
            return {
                items: action.businessCertificateReport
            };
        case userConstants.BUSINESSCERTIFICATEREPORT_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default businessCertificateReport;